import logo from "../../assets/images/logo.png";
import Card from "../Card/Card";
import aus from "../../assets/images/aus.png";
import usa from "../../assets/images/usa.png";
import { useEffect, useState } from "react";
import axios from "axios";
import BookCard from "../Card/BookCard";
import Button from "../Button/Button";
import { Link, useNavigate } from "react-router-dom";

export default function MostPopularCourse() {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const IMAGE_STATIC_URL = `${BASE_URL}/image/`;

  const [courses, setCourse] = useState([]);
 const navigate = useNavigate();
  // fetching all courses

  const fetchtopcourses = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/getallcourse`);
      if (response.data.status === 200) {
        setCourse(response.data.data);
        // console.log("datas", response.data.data)
      }
    } catch (error) {
      console.log(
        error?.response ? error?.response?.data?.message : error.message,
      );
    }
  };

  useEffect(() => {
    fetchtopcourses();
  }, []);

  const handleBuyBook = (course) => {
  const token = localStorage.getItem("userToken");

  // user login nahi hai
  if (!token) {
    alert("Please login to purchase");
    navigate("/login");
    return;
  }

  // selected course checkout me bhejo
  const selectedCourse = [
    {
      id: course._id,
      name: course.coursename,
      price: course.courseprice,
    },
  ];

  navigate("/checkout", {
    state: { courses: selectedCourse },
  });
};

  const videosources = [
    "https://player.cloudinary.com/embed/?cloud_name=dyhrd2zdv&public_id=dummy-video_a6apbm&profile=cld-default",
  ];

  const videosources2 = [
    "https://player.cloudinary.com/embed/?cloud_name=dyhrd2zdv&public_id=dummy-video_a6apbm&profile=cld-default",
  ];

  const austCourses = courses.filter(
    (item) => item?.flag?.toLowerCase().trim() === "aust",
  );
  const usaCourses = courses.filter(
    (item) => item?.flag?.toLowerCase().trim() === "usa",
  );


  return (
    <div className="lg:space-y-5">
      <h1 className="text-center font-bold text-xl lg:text-3xl px-2">
        Two Course Options: Workbook or Online Programs{" "}
      </h1>
      <p className="text-center lg:mb-5 px-4">
        These two videos provide an overview of the Kitehawk Workbook and Online
        Programs.
      </p>
    
      <div className="coursesBgImage py-5">

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-5 lg:py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* First Video */}
            <div>
              <p className="text-center lg:mb-5 px-4">
                <strong className=" text-xl lg:text-3xl px-1">
                  Short Video Overview of the Program.
                </strong>
                <br></br>
                This is a short overview of the Kitehawk Program
              </p>

              <div className="w-full sm:w-1/2 lg:w-1/3 mx-auto">
                {videosources &&
                  videosources.map((source, index) => {
                    return (
                      <div key={index} className="w-full aspect-video">
                        <iframe
                          src={source}
                          className="w-full h-full rounded-lg"
                          allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
                          allowFullScreen
                          frameBorder="0"
                        ></iframe>
                      </div>
                    );
                  })}
              </div>
            </div>

            {/* Second Video */}
            <div>
              <h1 className="text-center font-bold text-xl lg:text-3xl px-1">
                Kitehawk Professional Development Video.
              </h1>

              <p className="text-center lg:mb-5 px-4">
                This video is for teachers and tutors. This longer Professional
                Development Video examines in more depth, the strategy behind
                the Kitehawk Program. Many Online exercises are used to show
                similar exercises in the printed Workbook courses.
              </p>

              <div className="w-full sm:w-1/2 lg:w-1/3 mx-auto">
                {videosources2 &&
                  videosources2.map((source, index) => {
                    return (
                      <div key={index} className="w-full aspect-video">
                        <iframe
                          src={source}
                          className="w-full h-full rounded-lg"
                          allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
                          allowFullScreen
                          frameBorder="0"
                        ></iframe>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <h1 className="text-center font-bold text-xl lg:text-3xl px-1">
        Make Your Selection Here
      </h1>
      <div className="flex justify-center items-center  gap-x-5 my-3">
        <Link
          to="/books"
          className={`rounded-full primaryColor px-6 py-2 text-md font-bold text-white `}
        >
          Workbook Programs
        </Link>

        <Link
          to="/courses"
          className={`rounded-full primaryColor px-6 py-2 text-md font-bold text-white `}
        >
          Online Programs
        </Link>
      </div>

      <h1 className="text-center font-bold text-xl lg:text-3xl mb-1">
        Online Programs
      </h1>
      <h1 className="text-center font-bold text-lg lg:text-lg mb-0">
        Overview of the Kitehawk Programs
      </h1>
      <div className="coursesBgImage py-5">
        <p className="text-center lg:mb-5 lg:px-14">
          {/* Quick overview of Kitehawk LMS Show how easy it is to create courses,
          assign tasks, track progress. Crafted with premium-grade features */}
          Kitehawk offers 4 Online Programs which are suitable for Year or Grade 3 and above, including adults. Each workbook represents about a year’s work in a normal classroom. Select the required, USA courses or the Australian/NZ courses.
        </p>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-5 lg:py-12">
          {/* ================= USA PROGRAMS ================= */}
          {usaCourses.length > 0 && (
            <div>
              <h2 className="text-center font-bold text-md lg:text-3xl mb-5">
                USA Online Programs
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 justify-items-center">
                {usaCourses.map((item, index) => (
                  <BookCard
                    key={item._id || index}
                    title={item?.coursename}
                    // image={`${BASE_URL}/image/${item?.courseimage}`}
                    image={item?.courseimage?.startsWith("http") ? item.courseimage : `${IMAGE_STATIC_URL}${item?.courseimage}`}
                    imageClassName="w-40 h-40 sm:w-48 sm:h-48 object-contain mx-auto"
                    // onBuyNow={() => handleBuyBook(item.bookurl)}
                    onBuyNow={() => handleBuyBook(item)}
                    buttontext="BUY ONLINE PROGRAMS"
                    flag={item.flag} 
                  />
                ))}
              </div>
            </div>
          )}

          {/* ================= AUSTRALIA PROGRAMS ================= */}
          {austCourses.length > 0 && (
            <div className="mt-10 mb-10">
              <h2 className="text-center mt-4 font-bold text-md lg:text-3xl mb-5">
                Australian - NZ Online Programs
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 justify-items-center">
                {austCourses.map((item, index) => (
                  <BookCard
                    key={item._id || index}
                    title={item?.coursename}
                    // image={`${BASE_URL}/image/${item?.courseimage}`}
                    image={item?.courseimage?.startsWith("http") ? item.courseimage : `${IMAGE_STATIC_URL}${item?.courseimage}`}
                    imageClassName="w-40 h-40 sm:w-48 sm:h-48 object-contain mx-auto"
                    onBuyNow={() => handleBuyBook(item)}
                    buttontext="BUY ONLINE PROGRAMS"
                    flag={item.flag} 
                  />
                ))}
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}